import { NotificationMetadata } from '../../types';

export const formatNotificationText = (
  text: string,
  asHtml: boolean,
  metadata?: Partial<NotificationMetadata>
) => {
  metadata ||= {};
  if (asHtml)
    return text?.replace(/{(.*?)}/g, (_, p1) => {
      return `<b>${metadata[p1.trim() as keyof NotificationMetadata]}</b>`;
    });

  return text?.replace(/{(.*?)}/g, (_, p1) => {
    return `${metadata[p1.trim() as keyof NotificationMetadata]}`;
  });
};
